import { validateBankDetails } from "../../../../stores/Sepa/sepa.validation";
import { BankSelection } from "./BankAccountSelector";

/** DTO fragment shared by mandate / direct-debit-refund / einmal inputs. */
export interface BankDtoFields {
  bankAccountId?: string;
  holderFirstName?: string;
  holderLastName?: string;
  iban?: string;
  bic?: string;
}

/** Maps a resolved bank selection to the fields the SEPA DTOs expect. */
export function bankSelectionToDto(selection: BankSelection): BankDtoFields {
  if (selection.mode === "existing") {
    return { bankAccountId: selection.bankAccountId };
  }
  return {
    holderFirstName: selection.holderFirstName.trim(),
    holderLastName: selection.holderLastName.trim(),
    iban: selection.iban.replace(/\s+/g, "").toUpperCase(),
    bic: selection.bic.trim() || undefined,
  };
}

/**
 * Validates a bank selection. An existing account is always valid; inline details
 * go through `validateBankDetails`. Also flags an empty existing selection.
 */
export function validateBankSelection(selection: BankSelection): Record<string, string> {
  if (selection.mode === "existing") {
    return selection.bankAccountId ? {} : { bankAccountId: "Bitte eine Bankverbindung wählen" };
  }
  return validateBankDetails(selection);
}
